<template>
  <el-dialog
    title="选择员工"
    :visible.sync="visible"
    width="840px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.staffName"
        placeholder="请输入员工姓名"
        style="width: 200px"
        clearable=""
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        :resizable="false"
        width="30">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.staffId"
            :label="row.staffId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="员工编号"
        width="80"
        :resizable="false"
        prop="staffNumber">
      </el-table-column>
      <el-table-column
        label="员工姓名"
        width="140"
        :resizable="false"
        prop="staffName">
      </el-table-column>
      <el-table-column
        label="部门"
        :resizable="false"
        prop="departmentNams">
      </el-table-column>
      <el-table-column
        label="职位"
        width="200"
        :resizable="false"
        prop="positionNames">
      </el-table-column>
      <el-table-column
        width="110"
        label="手机号码"
        :resizable="false"
        prop="mobile">
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'StaffSelectModal',
  components: {},
  props: {
    callback: Function,
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        staffName: ''
      },
      options: {},
      total: 0,
      current: {}
    }
  },
  watch: {
    current: {
      handler(val) {
        console.log(val)
      },
      deep: true
    }
  },
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.staffId) {
        this.$message.error('请选择一个员工')
        return
      }
      this.callback && this.callback(this.current)
      if (this.autoClose) {
        this.toggleModal(false)
      }
    },
    handleCurrentRowChange(row) {
      this.current = row || {}
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch(`staff/getstaffs`, {
        payload: {
          orgId: 100,
          ...this.config
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(options) {
      this.options = options
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
